import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';

@Component({
  selector: 'app-roles-admin',
  templateUrl: './roles-admin.component.html',
  styleUrls: ['./roles-admin.component.css']
})
export class RolesAdminComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;
  public vecRoles = []; public vecAddRol = []; public tituloModal: string; private accion: number;

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarRoles(1);
  }

  //FUNCION QUE CARGA TODOS LOS ROLES REGISTRADOS EN EL SISTEMA
  async cargarRoles(op) {
    this.reiniciarTabla();

    this.vecRoles = [];
    this.cargando.abrir();
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(3, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objRol of res.roles) {
        if (op == 1) {
          if (objRol.intEstado == 1)
            this.agregarRolesVec(objRol.intIdRol, objRol.strNombre, objRol.strDescripcion, objRol.strIcono, objRol.intEstado == 1 ? "Activo" : "Inactivo");
        }
        else
          this.agregarRolesVec(objRol.intIdRol, objRol.strNombre, objRol.strDescripcion, objRol.strIcono, objRol.intEstado == 1 ? "Activo" : "Inactivo");
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //AGREGAR LOS ROLES DE USUARIO A SER MOSTRADOS SEGUN EL ESTADO
  agregarRolesVec(dato1, dato2, dato3, dato4, dato5) {
    this.vecRoles.push({
      codigo: dato1, nombre: dato2, describe: dato3, icono: dato4, estado: dato5
    });
  }
  //FUNCION QUE ABRE EL MODAL PARA AGREGAR UN NUEVO ROL
  async modalNuevoRol(nameMod) {
    this.tituloModal = "Agregar un rol nuevo al sistema"; this.accion = 1;
    this.borrarDatos();
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION PARA INSTANCIAR LAS VARIABLES
  borrarDatos() {
    this.vecAddRol = [];
    this.vecAddRol.push({ codigo: 'na', nombre: "", describe: "", icono: "", estado: 1 });
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS ROLES REGISTRADOS
  agregarRol() {
    this.srvInsert.ingresoGestionRoles(this.vecAddRol[0]['codigo'], this.vecAddRol[0]['nombre'], this.vecAddRol[0]['describe'], 'icono',
      this.vecAddRol[0]['estado'], this.accion).subscribe(res => {
        if (res.rol) {
          this.alerti.success('El rol ha sido agregado con éxito');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarRoles(1);
        }
        else
          this.alerti.error("No se puede agregar el rol");
      });
  }
  //FUNCION PARA ABRIL EL MODAL QUE PERMITE EDITAR UN ROL SELECCIONADO
  modalVerRol(nameMod, objRol) {
    this.tituloModal = "Editar información del rol"; this.accion = 2;
    this.buscarModRoles(objRol);
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE BUSCA UN ROL REGISTRADO EN EL SISTEMA DADO EL CODIGO
  async buscarModRoles(buscar) {
    this.cargando.abrir();
    this.vecAddRol = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionRoles(4, buscar, "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecAddRol.push({
        codigo: res.roles[0]['intIdRol'], nombre: res.roles[0]['strNombre'], describe: res.roles[0]['strDescripcion'],
        icono: res.roles[0]['strIcono'], estado: res.roles[0]['intEstado']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblRol').DataTable({ destroy: true });
    table3.destroy();
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
